import DataItemListResourceModel from '../../generated/types/model/resource/DataItemListResourceModel';

export default class DataItemListResourceViewModel extends DataItemListResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
